// extracted by mini-css-extract-plugin
export var cartIcon = "_lf-0";
export var cartIconContainer = "_lf-1";